import { LOCALE_ID, CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { BrowserModule } from "@angular/platform-browser";
import { RouteReuseStrategy, RouterModule } from "@angular/router";

import {
  HttpClientModule,
  HTTP_INTERCEPTORS,
  HttpClient,
} from "@angular/common/http";

import { IonicModule, IonicRouteStrategy } from "@ionic/angular";
import { StatusBar } from "@ionic-native/status-bar/ngx";

import { AppComponent } from "./app.component";
import { AppRoutingModule } from "./app-routing.module";
import { ScrollHideDirective } from "./directives/scroll-hide.directive";
import { HideHeaderDirective } from "./directives/hide-header.directive";
import { CurrencyPipe } from "@angular/common";
import { EpaycoPageModule } from "./modals/epayco/epayco.module";
import { EfectivorespuestaPageModule } from "./modals/efectivorespuesta/efectivorespuesta.module";

import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { File } from "@ionic-native/file/ngx";
import { FileOpener } from "@ionic-native/file-opener/ngx";

import { Clipboard } from "@ionic-native/clipboard/ngx";
import { SocialSharing } from "@ionic-native/social-sharing/ngx";

import { NetworkInterface } from "@ionic-native/network-interface/ngx";

import { ComponentsModule } from "./components/components.module";
import { FooterComponent } from "./components/footer/footer.component";

import { DatePipe } from "@angular/common";

import { NavParams } from "@ionic/angular";
import "@teamhive/stencil-pdf-viewer/dist/pdfviewer";
import { EpubComponent } from "./components/epub/epub.component";
import "@teamhive/stencil-pdf-viewer/dist/pdfviewer";
import { DragulaModule } from "ng2-dragula";
import { NativeDateAdapter } from "@angular/material/core";

import { DatePicker } from "@ionic-native/date-picker/ngx";
import { Network } from "@ionic-native/network/ngx";

import { AuthInterceptor } from "./api/auth.interceptor";
import { MoreComponent } from "./components/more/more.component";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";

import { NgxChartsModule } from "@swimlane/ngx-charts";
import { NgApexchartsModule } from "ng-apexcharts";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatButtonModule } from "@angular/material/button";
import "firebase/compat/auth";

// Firebase
import firebase from "firebase/compat/app";
import { AngularFireModule } from "@angular/fire/compat";
import { AngularFireDatabaseModule } from "@angular/fire/compat/database";
import { AngularFireAuthModule } from "@angular/fire/compat/auth";
import {
  TranslateModule,
  TranslateLoader,
  TranslateStore,
} from "@ngx-translate/core";
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MatInputModule } from "@angular/material/input";
import { MatSelectModule } from "@angular/material/select";
import { MatNativeDateModule } from "@angular/material/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";
import { TranslationLoadedService } from "./services/translation-loaded.service";

import { AppAvailability } from "@ionic-native/app-availability/ngx";
import { IonicSelectableComponent } from "ionic-selectable";
import { OAuthModule } from "angular-oauth2-oidc";
import { PublicLayoutComponent } from "./layout/public-layout/public-layout.component";
import { PrivateLayoutComponent } from "./layout/private-layout/private-layout.component";
import { IonicStorageModule } from "@ionic/storage-angular"; // 👈 AGREGAR
import { DeleteUserComponent } from './delete-user/delete-user.component';

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, "./assets/i18n/", ".json");
}

const lang = TranslationLoadedService.prototype.defaultLanguage$ ?? "es";

const firebaseConfig = {
  apiKey: "AIzaSyCLvkVwob-9QMOX1g0KjIFQgJgiUIB51N4",
  authDomain: "cronoleologin.firebaseapp.com",
  projectId: "cronoleologin",
  storageBucket: "cronoleologin.appspot.com",
  messagingSenderId: "1073834998340",
  appId: "1:1073834998340:web:3a69c82cc03ce76e085a11",
  measurementId: "G-17EERRCBC1",
};

@NgModule({
  declarations: [		
    AppComponent,
    ScrollHideDirective,
    HideHeaderDirective,
    PublicLayoutComponent,
    PrivateLayoutComponent,
      DeleteUserComponent
   ],
  imports: [
    RouterModule,
    BrowserModule,
    TranslateModule.forChild({
      defaultLanguage: lang.toString(),
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
      isolate: true,
      extend: true,
    }),
    BrowserAnimationsModule,
    IonicModule.forRoot(),
    NgApexchartsModule,
    AppRoutingModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    DragulaModule.forRoot(),
    AngularFireModule.initializeApp(firebaseConfig),
    AngularFireDatabaseModule,
    AngularFireAuthModule,
    NgxChartsModule,
    MatDatepickerModule,
    MatInputModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSelectModule,
    IonicSelectableComponent,
    OAuthModule.forRoot(),
    IonicStorageModule.forRoot(),
  ],
  providers: [
    TranslateStore,
    AppAvailability,
    StatusBar,
    Network,
    HttpClientModule,
    CurrencyPipe,
    NetworkInterface,
    EfectivorespuestaPageModule,
    EpaycoPageModule,
    DatePipe,
    NavParams,
    DatePicker,
    NativeDateAdapter,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    FileOpener,
    Clipboard,
    SocialSharing,
    { provide: LOCALE_ID, useValue: "CO" },
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  exports: [FooterComponent, EpubComponent, TranslateModule],
})
export class AppModule {}
